<template>
  <div class="complectation-element-manage flex flex-col">
    <div class="title flex justify-between items-center">
      <span>{{$t('client.plots.title')}}</span>
      <button @click="$store.dispatch('clientMain/setManageElement', null)">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="body flex-1 overflow-x-hidden">
      <div class="manage-step">
        <div class="manage-step-title">{{$t('client.plots.select_size_plot')}}</div>
        <div class="manage-step-body">

          <div
            class="relative flex items-center"
            v-if="settings.plot_mode == 'list_and_custom'"
          >
            <input
              type="radio"
              class="landscaping__types-radio"
              name="plot_mode"
              id="plot_mode_list"
              value="list"
              :checked="selectedPlot.mode=='list'"
              @click="selectPlotMode('list')"
            />
            <label
              class="landscaping__types-label"
              for="plot_mode_list"
            ><span class="landscaping__types-icon"><span></span></span> {{$t('client.plots.plot_mode_list')}}</label>
          </div>

          <div
            v-if="(settings.plot_mode == 'list' || settings.plot_mode == 'list_and_custom')&&selectedPlot.mode=='list'"
            class="choose-element-list plots flex items-start flex-wrap overflow-x-hidden"
          >

            <button
              @click="$store.dispatch('clientPlots/select', plot)"
              class="choose-element-item relative focus:outline-none flex justify-center items-center"
              :class="{
                selected: selectedPlot && selectedPlot.plot_id == plot.plot_id,
              }"
              v-for="plot in plots"
              :key="`choose-plot-${plot.plot_id}`"
            >
              <i
                class="fas fa-check absolute top-2 right-2"
                v-if="selectedPlot && selectedPlot.plot_id == plot.plot_id"
              ></i>
              <div class="img">
                <img
                  class="object-cover"
                  src="/images/client/elements/plot-img.svg"
                  alt=""
                />
              </div>
              <div class="size absolute bottom-1 w-full text-center">
                {{ plot.size }}
              </div>
            </button>

          </div>
          <div
            class="relative flex items-center mt-4"
            v-if="settings.plot_mode == 'list_and_custom'"
          >
            <input
              type="radio"
              class="landscaping__types-radio"
              name="plot_mode"
              id="plot_mode_custom"
              value="custom"
              :checked="selectedPlot.mode=='custom'"
              @click="selectPlotMode('custom')"
            />
            <label
              class="landscaping__types-label"
              for="plot_mode_custom"
            > <span class="landscaping__types-icon"><span></span></span>{{$t('client.plots.plot_mode_custom')}}</label>
          </div>
          <div
            class="plot-custom-size mt-2"
            v-if="(settings.plot_mode == 'list_and_custom' || settings.plot_mode == 'custom')&&selectedPlot.mode=='custom'"
          >
            <div class="plot-custom-size__inputs">
              <div class="size-block">
                <label for="plot-length">{{$t('client.plots.plot_length')}}</label>
                <input
                  id="plot-length"
                  type="number"
                  :min="settings.plot_length_min"
                  :max="settings.plot_length_max"
                  v-model="length"
                  :class="{'error': errorLength}"
                  oninput="this.value = Math.round(this.value);"
                >
              </div>
              <div class="pb-2"><img
                  src="/images/design/perekrestie.svg"
                  alt="#"
                ></div>
              <div class="size-block">
                <label for="plot-length">{{$t('client.plots.plot_width')}}</label>
                <input
                  id="plot-length"
                  type="number"
                  :min="settings.plot_width_min"
                  :max="settings.plot_width_max"
                  v-model="width"
                  :class="{'error': errorWidth}"
                  oninput="this.value = Math.round(this.value);"
                >
              </div>
            </div>

            <div class="plot-custom-size__limits">
              <div> {{$t('client.plots.plot_length_limit', {plot_length_min:settings.plot_length_min, plot_length_max: settings.plot_length_max})}}</div>
              <div>
                {{$t('client.plots.plot_width_limit', {plot_width_min:settings.plot_width_min, plot_width_max: settings.plot_width_max})}} </div>
            </div>
            <div
              class="plot-custom-size__errors"
              v-if="errors.length"
            >
              <div v-for="error in errors">
                {{ error }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: "Plots",
  data() {
    return {
      length: 0,
      width: 0,
      errors: [],
      errorWidth: false,
      errorLength: false,
    };
  },
  created() {
    this.$store.dispatch("clientPlots/fetch");
  },
  mounted() {
    this.length =
      (this.selectedPlot && this.selectedPlot.length) ||
      this.settings.plot_length_default ||
      this.settings.plot_length_min;
    this.width =
      (this.selectedPlot && this.selectedPlot.width) ||
      this.settings.plot_width_default ||
      this.settings.plot_width_min;

    if (this.settings.plot_mode == "list" && this.selectedPlot.mode != "list") {
      this.selectPlotMode("list");
    }

    if (
      this.settings.plot_mode == "custom" &&
      this.selectedPlot.mode != "custom"
    ) {
      this.selectPlotMode("custom");
    }
  },
  computed: {
    plots() {
      return this.$store.state.clientPlots.plots;
    },
    settings() {
      return this.$store.state.settings.settings;
    },
    selectedPlot() {
      return this.$store.state.clientOrder.plot;
    },
  },
  methods: {
    selectPlotMode(mode) {
      this.$store.dispatch("clientOrder/setPlotMode", mode);
    },
    changePlotSize() {
      this.errors = [];
      this.errorWidth = false;
      this.errorLength = false;

      let message = "";

      if (parseFloat(this.length) < parseFloat(this.settings.plot_length_min)) {
        message = "Превышен лимит минимально допустимых значений длины!";
        this.errors.push(message);
        message = `Выставлен минимальный лимит длины: ${this.settings.plot_length_min} см`;
        this.errors.push(message);
        this.errorLength = true;
      }

      if (parseFloat(this.length) > parseFloat(this.settings.plot_length_max)) {
        message = "Превышен лимит максимально допустимых значений длины!";
        this.errors.push(message);
        message = `Выставлен максимальный лимит длины: ${this.settings.plot_length_max} см`;
        this.errors.push(message);
        this.errorLength = true;
      }

      if (parseFloat(this.width) < parseFloat(this.settings.plot_width_min)) {
        message = "Превышен лимит минимально допустимых значений ширины!";
        this.errors.push(message);
        message = `Выставлен минимальный лимит ширины: ${this.settings.plot_width_min} см`;
        this.errors.push(message);
        this.errorWidth = true;
      }

      if (parseFloat(this.width) > parseFloat(this.settings.plot_width_max)) {
        message = "Превышен лимит максимально допустимых значений ширины!";
        this.errors.push(message);
        message = `Выставлен максимальный лимит ширины: ${this.settings.plot_width_max} см`;
        this.errors.push(message);
        this.errorWidth = true;
      }

      if (!this.errors.length) {
        this.$store.dispatch("clientOrder/setPlotSize", {
          length: this.length,
          width: this.width,
        });
      }
    },
  },
  watch: {
    width() {
      this.changePlotSize();
    },
    length() {
      this.changePlotSize();
    },
  },
};
</script>
<style scoped>
.plot-custom-size__inputs {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  margin-bottom: 20px;
  column-gap: 10px;
  align-items: flex-end;
}
.size-block {
  display: flex;
  flex-direction: column;
  row-gap: 7px;
}
.size-block label {
  font-size: 14px;
  color: #22272f;
}

.size-block input {
  width: 100%;
  height: 48px;
  text-align: center;
  padding: 0 10px;
  font-size: 24px;
  border-radius: 4px;
  border: 1px solid #bcd0dd;
  outline: none;
  color: #22272f;
}
.size-block input.error {
  border-color: #ff0000;
}

.plot-custom-size__limits,
.plot-custom-size__errors {
  font-size: 12px;
  color: #808284;
  display: flex;
  flex-direction: column;
  row-gap: 2px;
}

.plot-custom-size__errors {
  margin-top: 10px;
  color: #ff0000;
}

@media screen and (max-width: 1000px) {
  .complectation-element-manage {
    width: 300px;
  }
}
</style>
